import { Avatar, Flex, Space, Typography } from "antd";
import { useTexts } from "hooks/useTexts";
import React, { ReactNode } from "react";
import BubbleButton from "ui/BubbleButton";
import DateDisplay, { type DateDisplayMode } from "ui/DateDisplay";
import ShareLink from "ui/ShareLink";
import Spacer from "ui/Spacer";
const { Text } = Typography;

type CardHeaderProps = {
  showTopToggle: boolean;
  avatarElement: ReactNode;
  PersonBlock: ReactNode;
  meta: { dateModified?: string; dateCreated?: string } | undefined;
  cardUrl: string | undefined;
  toggleClick: () => void;
  toggleText: ReactNode;
  dateDisplayMode?: DateDisplayMode;
};

const CardHeader: React.FC<CardHeaderProps> = ({
  showTopToggle,
  avatarElement,
  PersonBlock,
  meta,
  cardUrl,
  toggleClick,
  toggleText,
  dateDisplayMode = "modified",
}) => {
  const { txt } = useTexts("case");

  return (
    <Spacer rightmost={showTopToggle}>
      <Space
        direction="horizontal"
        style={{ padding: "6px 0px", fontWeight: "normal" }}
      >
        <Avatar
          size="large"
          icon={avatarElement}
        />
        <Flex vertical={true}>
          {PersonBlock}
          {/*@ts-ignore*/}
          <Text>
            <DateDisplay
              dateModified={meta?.dateModified}
              dateCreated={meta?.dateCreated}
              mode={dateDisplayMode}
            />{" "}
            <ShareLink
              url={cardUrl}
              elementName={txt("link_to_card", "карточку")}
            />
          </Text>
        </Flex>
      </Space>

      {showTopToggle && (
        <BubbleButton
          className="right"
          size="m"
          onClick={toggleClick}
          text={toggleText}
          autosize={false}
          square={true}
        />
      )}
    </Spacer>
  );
};

export default CardHeader;
